<template>
  <div class="wx_group_preview_box">
    <el-dialog    v-model="dialogVisible" title="发送预览" width="80%" destroy-on-close :close-on-click-modal="false">
      <el-table stripe :data="tableData" style="width: 100%" height="60vh">
        <el-table-column prop="studentCode" label="学员编码" min-width="150px" />
        <el-table-column prop="studentName" label="学员姓名" min-width="100px" />
        <el-table-column prop="chatGroupName" label="接收微信群" min-width="200px" />
        <el-table-column label="发送条数" min-width="90px">
          <template #default="scope">
            <span>{{ scope.row.sendContents.length }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in contentColumns" :label="item" min-width="250px">
          <template #default="scope">
            <!-- <span>{{ JSON.stringify(scope.row.sendContents[index].sendContent) }}</span> -->
            <fileCard v-if="scope.row.sendContents[index] && scope.row.sendContents[index]?.msgType != 'text'"
              :file-data="scope.row.sendContents[index]"></fileCard>
            <span v-else>{{ scope.row.sendContents[index]?.sendContent || scope.row.sendContents[index]?.path }}</span>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <div class="dialog-footer">
          <el-text class="mx-1"
            type="warning">共发送<span>{{ studentNumber }}</span>个学员，<span>{{ msgNumber }}</span>条消息，预计完成时间：{{
      formatRetainTime(sendTime) }}</el-text>
          <el-button type="primary" @click="confirm">
            发送
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import fileCard from '@/components/fileCard.vue'
import { computed, ref } from 'vue';
import { getSendTime } from '@/utils/callingAppApi'
import { formatRetainTime } from '@/utils/util'
import { transformTableDataSendToApp } from '@/utils/resolveData.js'

const emit = defineEmits(['send', 'update:modelValue']);
const props = defineProps(['tableData', 'modelValue']);
const studentNumber = ref(0)
const msgNumber = ref(0);
const sendTime = ref(0);
const dialogVisible = computed({
  get: () => props.modelValue,
  set: () => emit('update:modelValue')
})

const contentColumns = computed(() => {

  let maxContent = [];
  studentNumber.value = 0;
  msgNumber.value = 0;
  props.tableData.forEach(item => {
    studentNumber.value++;
    msgNumber.value += item.sendContents.length;
    if (item.sendContents.length > maxContent.length) {
      maxContent = item.sendContents.map((v, i) => '群发内容' + (i + 1))
    }
  })
  getSendTime(transformTableDataSendToApp(props.tableData), (res) => {
    sendTime.value = res.time
  })
  return maxContent
})

// const tableData = [
//   {
//     date: '2016-05-03',
//     name: 'Tom',
//     address: 'No. 189, Grove St, Los Angeles',
//   }
// ]
const confirm = () => {
  emit('send')
}
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
}
</style>